import { api } from './api';
import { Invoice, InvoiceStatus } from '../types';

export interface CreateInvoiceRequest {
  caseId: string;
  timeEntryIds: string[];
  rate: number; // cents per hour
  taxRate?: number;
  notes?: string;
  dueDate?: string;
}

export interface UpdateInvoiceRequest {
  status?: InvoiceStatus;
  notes?: string;
  dueDate?: string;
  issueDate?: string;
  taxRate?: number;
  lineItems?: {
    index: number;
    rate: number;
  }[];
}

export interface SendInvoiceResponse {
  invoiceId: string;
  sentAt: string;
  recipientEmail: string;
}

export const invoicesApi = {
  list: async (caseId?: string, status?: InvoiceStatus): Promise<{ invoices: Invoice[]; count: number }> => {
    const params = new URLSearchParams();
    if (caseId) params.append('caseId', caseId);
    if (status) params.append('status', status);
    const queryString = params.toString();
    return api.get<{ invoices: Invoice[]; count: number }>(`/invoices${queryString ? `?${queryString}` : ''}`);
  },

  get: async (id: string): Promise<Invoice> => {
    return api.get<Invoice>(`/invoices/${id}`);
  },

  create: async (data: CreateInvoiceRequest): Promise<Invoice> => {
    return api.post<Invoice>('/invoices', data);
  },

  update: async (id: string, data: UpdateInvoiceRequest): Promise<Invoice> => {
    return api.put<Invoice>(`/invoices/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    return api.delete<void>(`/invoices/${id}`);
  },

  send: async (id: string): Promise<SendInvoiceResponse> => {
    return api.post<SendInvoiceResponse>(`/invoices/${id}/send`, {});
  },

  remind: async (id: string): Promise<{ invoiceId: string; sentAt: string; recipientEmail: string }> => {
    return api.post<{ invoiceId: string; sentAt: string; recipientEmail: string }>(`/invoices/${id}/remind`, {});
  },
};
